import api from '../../plugins/api';

/**
 * Отчёт из админки.
 *
 * Ходим через свой бэкенд, а не напрямую в админку: раньше запрос уходил из
 * браузера менеджера на admin.doscar.kz, и у тех, у кого нет доступа к админке,
 * скачивание падало с ошибкой CORS. Бэкенд забирает файл со своей стороны и
 * отдаёт его нам — доступ к админке менеджеру больше не нужен.
 */
const downloadReport = (data) => {
  return api.post('/api/crm/reports/download', data, { responseType: 'blob' });
};

export default downloadReport;
